import request from "@/utils/request";
//获取会员预约查询信息
// export const literature = (date) => {
//   return request({
//     url: "/api/cust/appoint/selectByID",
//     method: "POST",
//     params: date
//   })
// }
//分页表格数据
export const Curepaging = (date) => {
  return request({
    url: "/api/cust/appoint/selectPage",
    method: "POST",
    params: date
  })
}
//头部区域信息
export const regionalQuery = (date) => {
  return request({
    url: "/api/shop/queryRegion",
    method: "POST",
    params: date
  })
}
//预约门店信息展示
export const redistRict = (date) => {
  return request({
    url: "api/shop/selectByCode?shopCode=",
    method: "POST",
    params: date
  })
}
//会员消费等级请求数据接口
export const resgrade = (date) => {
  return request({
    url: "api/Custlvl/querySelect",
    method: "POST",
    params: date
  })
}
//详情初始化
export const particulars = (date) => {
  return request({
    url: "/api/cust/appoint/selectByID",
    method: "POST",
    params: date
  })
}
//修改预约接口数据
export const reservation = (date) => {
  return request({
    url: "/api/cust/appoint/updateByID",
    method: "POST",
    params: date
  })
}

//取消预约原因接口
export const countermand = (date) => {
  return request({
    url: "/api/reason/selectList",
    method: "POST",
    params: date
  })
}
//选择会员信息
export const Usermembers = (date) => {
  return request({
    url: "/api/cust/selectCustList",
    method: "POST",
    params: date
  })
}
//获取商品SKU列表
export const Goodssku = (date) => {
  return request({
    url: "/api/product/getSkuList",
    method: "POST",
    params: date
  })
}
//创建售后，跟试衣接口数据
export const addpivottablea = (date) => {
  return request({
    url: "/api/cust/appoint/insert",
    method: "POST",
    params: date
  })
}
//获取编号接口
export const getinformation = (date) => {
  return request({
    url: "/api/cust/appoint/getAppointmentNo",
    method: "POST",
    params: date
  })
}
//删除接口
export const delectByID = (date) => {
  return request({
    url: "/api/cust/appoint/delectByID",
    method: "POST",
    params: date
  })
}
//图片上传接口
export const uploadImgApi = (date) => {
  return request({
    url: `/api/uploadImg?type=2`,
    method: "POST",
    data: date
  })
}
// export const delectByes = (params) => request.post('/api/cust/appoint/delectByID', params)
//上传图片接口

// export const ssss=(params)=>request.post("/api/cust/appoint/getAppointmentNo",params)


